import { useAppSelector } from "integrations/redux/hooks"
import { selectSidePanelMode } from "./slice.new"
import { useMemo } from "react"
import { useHasSearchOrFilter } from "./SidePanelSearchAndFilter"

export function SidePanelListEmptyState() {
    const sidePanelMode = useAppSelector(selectSidePanelMode)
    const hasSearchOrFilter = useHasSearchOrFilter()
    const title = useMemo(() => {
        if (hasSearchOrFilter) return "No Results"
        if (sidePanelMode === "PDFs") return "Create a PDF"
        return "Get Started"
    }, [hasSearchOrFilter, sidePanelMode])
    const body = useMemo(() => {
        if (hasSearchOrFilter) return "Edit your search or filters."
        if (sidePanelMode === "PDFs")
            return "Click the Create button above, then choose Generate PDF from the dropdown."
        return "Click the Create button above, then choose a Feature from the dropdown"
    }, [hasSearchOrFilter, sidePanelMode])
    return (
        <div className="flex flex-col justify-center items-center gap-1 pt-8 px-3">
            <h5 className="text-white">{title}</h5>
            <small className="text-gray-100 text-center">{body}</small>
        </div>
    )
}
